import { SetDutiesPayerActionStep } from "@redotech/redo-flows-common/oms/actions";
import { useTranslation } from "@redotech/redo-i18n";
import { RedoRadioGroup } from "@redotech/redo-web/arbiter-components/radio/redo-radio-group";
import { memo } from "react";
import { PartialWithRequiredType } from ".";

export const DutiesPayerRadioGroup = memo(function DutiesPayerRadioGroup({
  step,
  setStep,
}: {
  step: PartialWithRequiredType<SetDutiesPayerActionStep>;
  setStep: (step: PartialWithRequiredType<SetDutiesPayerActionStep>) => void;
}) {
  const { t } = useTranslation();
  return (
    <RedoRadioGroup
      options={[
        { id: "DDP", label: t("Shipper paid (DDP)") },
        { id: "DAP", label: t("Customer paid (DAP)") },
      ]}
      setValue={(value) => {
        setStep({ ...step, ddp: value === "DDP" });
      }}
      size="xs"
      value={step.ddp === true ? "DDP" : step.ddp === false ? "DAP" : undefined}
    />
  );
});
